import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import HeaderAndSearch from "./HeaderAndSearch";
import CommunityCard from "../home/CommunityCard";

import SeoLinks from "./SeoLinks";
import HomeFooter from "./HomeFooter";

const Home = () => {
    const [communities, setCommunities] = useState([]);
    const { favourites } = useSelector((state) => state.local);

    console.log(favourites);

    const activeFavorites = Object.keys(favourites).filter((nameId) => favourites[nameId]);
    const searchBody = JSON.stringify({ nameIds: activeFavorites });

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch("/api/search", {
                method: "POST",
                body: searchBody,
            });

            const data = await res.json();

            if (data.data && data.data.communitys) {
                setCommunities(data.data.communitys);
            } else {
                setCommunities([]);
            }
        };

        fetchData();
    }, [searchBody]);

    return (
        <div>
            <HeaderAndSearch />

            <div className="bg-white overflow-x-hidden">
                <div className="mt-8 mb-8 container mx-auto px-4 sm:px-16">
                    <h2 className="text-primary-500 text-2xl font-headline font-bold">
                        My Favorite Communities
                    </h2>

                    {communities.length === 0 ? (
                        <div className="mt-4">
                            <p className="text-lg">
                                You don't have any favorite communities yet.
                                <br />
                                Search for communities and click on the heart to favorite
                                them.
                            </p>
                        </div>
                    ) : null}

                    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-8">
                        {communities.map((community) => (
                            <CommunityCard key={community.nameId} community={community} />
                        ))}
                    </div>
                </div>
            </div>

            <SeoLinks enable={true} />
            <HomeFooter />
        </div>
    );
};

export default Home;
